module.exports = __webpack_public_path__ + "static/img/all-bg.2025.109bf17.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/openSalesmanShop/all-bg.2025.jpg
// module id = 5kbG
// module chunks = 0